export function deepCopy(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  let copy = Array.isArray(obj) ? [] : {};
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (typeof obj[i] === "object") {
        copy[i] = deepCopy(obj[i]);
      } else {
        copy[i] = obj[i];
      }
    }
  }
  return copy;
}

export const formatCurrency = (num) => {
  let _num = Number(num);
  if (isNaN(_num)) return num;
  return _num.toLocaleString();
};

// 2025-05-13 추가
export function normalizeUrl(url) {
  try {
    // 상대 경로면 현재 origin을 붙여 절대 URL로 변환
    if (!/^https?:\/\//i.test(url)) {
      url = window.location.origin + (url.startsWith("/") ? url : "/" + url);
    }

    const parsedUrl = new URL(url);
    const currentHost = window.location.hostname;

    const hasWWWInCurrent = currentHost.startsWith("www.");
    const hasWWWInURL = parsedUrl.hostname.startsWith("www.");

    if (hasWWWInCurrent && !hasWWWInURL) {
      // 현재는 www인데 url에는 없으면 붙이기
      parsedUrl.hostname = "www." + parsedUrl.hostname;
    } else if (!hasWWWInCurrent && hasWWWInURL) {
      // 현재는 www 없는데 url에는 있으면 제거
      parsedUrl.hostname = parsedUrl.hostname.replace(/^www\./, "");
    }

    return parsedUrl.href;
  } catch (err) {
    console.error("URL 정규화 중 오류:", err);
    return url;
  }
}

export function downloadFile(url, filename) {
  // 如果URL是相对路径，转换为绝对路径 URL이 상대 경로라면, 절대 경로로 변환합니다.
  if (url.startsWith("/")) {
    url = window.location.origin + url;
  }

  // 2025-05-13 추가
  url = normalizeUrl(url);

  // 创建一个新的XMLHttpRequest 새 XMLHttpRequest 만들기
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";

  xhr.onload = function () {
    if (this.status === 200) {
      // 创建一个新的Blob对象 새 Blob 개체를 만듭니다.
      const blob = new Blob([this.response], { type: "application/pdf" });

      // 创建一个指向Blob的URL  Blob을 위한 URL 만들기
      const blobUrl = URL.createObjectURL(blob);

      // 创建一个下载链接   다운로드 링크 만들기
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;

      // 模拟点击下载   모의 다운로드
      document.body.appendChild(link);
      link.click();

      // 清理
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }, 100);
    } else {
      console.error("파일 다운로드 실패, 상태 코드:", this.status);
      alert("파일 다운로드에 실패했습니다. 잠시 후에 다시 시도하십시오");
    }
  };

  xhr.onerror = function () {
    console.error("파일 다운로드 요청 실패");
    alert("파일 다운로드에 실패했습니다. 잠시 후에 다시 시도하십시오");
  };

  // 发送请求 요청 보내기
  xhr.send();
}
